import {
  handleChangeFilter,
  handleChangeValues,
  handleDelete,
  loading,
  refreshFilters,
  resetFilters,
} from '../store/additionalFilters'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Mana from './Mana'
import Spinner from './Spinner'
import Typeahead from './Typeahead'
import classNames from 'classnames'
import { preloadCards } from '../store/pagedata'
import styles from '../styles/AdditionalFilters.module.scss'
import { useState } from 'react'

const Row = ({
  filter,
  hideRemove,
  noPad,
  onChangeFilter,
  onChangeValues,
  onDelete,
}) => {
  const { key, type, values } = filter
  return (
    <Form.Row className={classNames('align-items-center', { 'pb-2': !noPad })}>
      <Col xs='auto'>
        <Form.Control as='select' onChange={onChangeFilter} value={type}>
          <option value=' '>Additional Filters...</option>
          <option value='cardName'>Card Name</option>
          <option value='typeLine'>Type Line</option>
          <option value='colors'>Colors</option>
          <option value='manaValue'>Mana Value</option>
          <option value='power'>Power</option>
          <option value='toughness'>Toughness</option>
          <option value='rarity'>Rarity</option>
          <option value='sets'>Sets</option>
          <option value='tags'>Tags</option>
          <option value='price'>Price</option>
        </Form.Control>
      </Col>
      {hideRemove || (
        <Col xs='auto'>
          <Form inline>
            {['cardName', 'typeLine'].includes(type) ? (
              <Form.Control
                onChange={(e) => onChangeValues({ value: e.target.value })}
                value={values.value}
              />
            ) : ['manaValue', 'power', 'price', 'toughness'].includes(type) ? (
              <>
                <Form.Control
                  as='select'
                  className='mr-sm-2'
                  onChange={(e) => onChangeValues({ operator: e.target.value })}
                  value={values.operator}
                >
                  <option value='>'>&gt;</option>
                  <option value='>='>&ge;</option>
                  <option value='==='>=</option>
                  <option value='<'>&lt;</option>
                  <option value='<='>&le;</option>
                  <option value='!=='>&ne;</option>
                </Form.Control>
                <Form.Control
                  className={styles.number}
                  onChange={(e) => onChangeValues({ value: e.target.value })}
                  type='number'
                  value={values.value}
                />
              </>
            ) : type === 'colors' ? (
              <>
                {['w', 'u', 'b', 'r', 'g', 'c'].map((color) => (
                  <Form.Check
                    checked={values[color]}
                    className='mr-sm-2'
                    id={`${key}-${color}`}
                    key={`${key}-${color}`}
                    label={
                      <span className={styles.color}>
                        <Mana className={styles.mana} color={color} />
                      </span>
                    }
                    onChange={() => onChangeValues({ [color]: !values[color] })}
                    type='checkbox'
                  />
                ))}
                <Form.Control
                  as='select'
                  onChange={(e) => onChangeValues({ operator: e.target.value })}
                  value={values.operator}
                >
                  <option value='EXCLUSIVE ALL'>Exactly these colors</option>
                  <option value='INCLUSIVE ALL'>Including these colors</option>
                  <option value='SOME'>At most these colors</option>
                </Form.Control>
              </>
            ) : type === 'rarity' ? (
              <Form.Control
                as='select'
                onChange={(e) => onChangeValues({ value: e.target.value })}
                value={values.value}
              >
                <option value='common'>Common</option>
                <option value='uncommon'>Uncommon</option>
                <option value='rare'>Rare</option>
                <option value='mythic'>Mythic</option>
              </Form.Control>
            ) : type === 'sets' ? (
              <>
                <Form.Control
                  as='select'
                  className='mr-sm-2'
                  onChange={(e) => onChangeValues({ operator: e.target.value })}
                  value={values.operator}
                >
                  <option value='INCLUDE'>Include</option>
                  <option value='EXCLUDE'>Exclude</option>
                </Form.Control>
                <Typeahead
                  onChange={(sets) =>
                    onChangeValues({ sets: sets.map(({ code }) => code) })
                  }
                  type='sets'
                />
              </>
            ) : type === 'tags' ? (
              <Typeahead
                onChange={(tags) =>
                  onChangeValues({ value: tags.map(({ id }) => id) })
                }
                type='tags'
              />
            ) : null}
          </Form>
        </Col>
      )}
      {hideRemove || (
        <Button className='px-0' onClick={onDelete} variant='link'>
          remove
        </Button>
      )}
    </Form.Row>
  )
}

const AdditionalFilters = () => {
  const dispatch = useDispatch()
  const filters = useSelector((state) => state.additionalFilters.filters)
  const isLoading = useSelector((state) => state.additionalFilters.isLoading)
  const [preloaded, setPreloaded] = useState(false)

  return (
    <div>
      {filters.map((filter, i) => (
        <Row
          filter={filter}
          key={filter.key}
          onChangeFilter={(e) => dispatch(handleChangeFilter({ e, i }))}
          onChangeValues={(values) =>
            dispatch(handleChangeValues({ i, values }))
          }
          onDelete={() => dispatch(handleDelete(i))}
        />
      ))}
      <Row
        filter={{ type: '' }}
        hideRemove
        noPad
        onChangeFilter={(e) =>
          dispatch(handleChangeFilter({ e, i: filters.length + 1 }))
        }
        onReset={() => dispatch(resetFilters())}
      />
      <Form.Row>
        {(preloaded || filters.length > 0) && (
          <>
            <Col xs='auto'>
              <Button
                className='mt-2'
                disabled={isLoading}
                onClick={() => {
                  if (!preloaded) {
                    dispatch(loading())
                    setPreloaded(true)
                    dispatch(preloadCards())
                  } else {
                    dispatch(refreshFilters())
                  }
                }}
              >
                {isLoading ? <Spinner /> : 'Submit'}
              </Button>
            </Col>
            <Col xs='auto'>
              <Button
                className='mt-2 px-0'
                disabled={isLoading}
                onClick={() => dispatch(resetFilters())}
                variant='link'
              >
                reset
              </Button>
            </Col>
          </>
        )}
      </Form.Row>
    </div>
  )
}

export default AdditionalFilters
